import React, { useState, useEffect } from "react";
import images from "../images";
import photocard_images from "./object-lists/photocard-images";
import { collection, doc, setDoc, onSnapshot  } from "firebase/firestore"; 
import { database } from "../firebaseConfig2";

function Blorbo(props) {
  // console.log("In BLORBO");


    const [status, setStatus] = useState({
       date: 'Loading...',
        img: 'Loading...',
        message: 'Loading...',
        name: 'Loading...',
        origin: 'Loading...',
        origin_link: 'Loading...'
    });
    const [statusList, setStatusList] = useState([]);
    
    useEffect(
    () =>
      onSnapshot(collection(database, "mkcp_blorbos"), (snapshot) => {
        snapshot.forEach((doc) => {
          let tempdate = new Date(doc.data().date).toLocaleDateString("en-US");

          if (tempdate == "Invalid Date"){
            tempdate = doc.data().date;
          }
          let tempstatus = {
            date: tempdate,
            img: doc.data().img,
            message: doc.data().message,
            name: doc.data().name,
            origin: doc.data().origin,
            origin_link: doc.data().origin_link
          }
          setStatusList(statusList.push(tempstatus));
        });
        setStatus(statusList.at(-1));
      }),
    []
  );


    return (
    <div className='status-wrapper' id="blorbo-wrapper">
          
        <div className='status-title'> 
            <p>⊹ featured fav</p> 
            <p>{status.date}</p>
        </div>

        <div className="status-details" id="blorbo-details" >
            {/* <img className = "hologif" src={hologif}></img> */}
            <div className="blorbo-image">
              <img className = 'photocard' src={status.img} alt={status.name}></img>
            </div>
            <div className="blorbo-heading">
              <h3 id="blorbo-title">{status.name}</h3>
              <div className="oc-info" id="blorbo-info">
                {(status.origin_link != "") ?
                    <p>☽ .* ─ 
                    <a href={status.origin_link} target="_blank" rel="noopener noreferrer">
                      {status.origin}
                    </a></p>
                    :
                    <p>☽ .* :☆ﾟ. ─── {status.origin}</p>
                    }
              </div>
              </div>
            <p className="status-message" id="blorbo-message">{status.message}</p>
            
        </div>
      </div>
    );
  }

  export default Blorbo;